import { StateModel_Initialization } from '../store';
import { ActionTypes } from '../actions/types';

const initialState: StateModel_Initialization = {
  isInitialized: false,
};

export default function (
  state = initialState,
  action: { type: ActionTypes; payload: any }
) {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.SET_INITIALIZED:
      return {
        ...state,
        isInitialized: payload,
      };
    default:
      return state;
  }
}
